<template>
  <div class="calculator-form" :class="alertColor ? 'alert' : ''">
    <form @submit.prevent="calculate">
      
      <div class="form-group">
        <label for="sex">Sexo/Sex:</label>
        <select v-model="formData.sex" id="sex" required>
          <option value="M">Masculino/Male</option>
          <option value="F">Femenino/Female</option>
        </select>
      </div>
      <div class="form-group">
        <label>Edad/Age:</label>
        <input type="number" min="1" step="1" max="17"  v-model="formData.age" required />
      </div>
      <div style="display: flex; justify-content: space-around;">
        <div class="form-group">
          <input type="radio" id="months" value="months" v-model="formData.ageUnit" />
          <label for="months">Meses <sub>Months</sub></label>
        </div>
        <div class="form-group">
          <input type="radio" id="years" value="years" v-model="formData.ageUnit" />
          <label for="years">Años <sub>Years</sub></label>
        </div>
      </div>
      <div class="form-group">
        <label for="height">Talla/Height (cm):</label>
        <input type="number" v-model="formData.height" id="height" required />
      </div>
      <div class="form-group" v-if="isUmolSet">
        <label for="creatinine">Creatinina/Creatinine (mg/dL):</label>
        <div for="creatinine">
          <input :disabled="isUmolSet" type="number" v-model="results.creatinineUmol" min="0.01" step="0.01" max="16.00" id="creatinine" :required="!isUmolSet" />
        </div>
      </div>
      <div class="form-group" v-else>
        <label for="creatinine">Creatinina/Creatinine (mg/dL):</label>
        <div for="creatinine">
          <input :disabled="isUmolSet" type="number" v-model="formData.creatinine" min="0.01" step="0.01" max="16.00" id="creatinine" :required="!isUmolSet" />
        </div>
      </div>
      <div class="form-group">
        <label for="umol">Creatinina/Creatinine (umol/L):</label>
        <div for="umol">
          <input :disabled="formData.creatinine > 0" :placeholder="results.creatinineMg > 0 ? results.creatinineMg : ''" type="number" id="umol" min="0.00" step="0.1" max="999.00" v-model="formData.umol" style="width: 100px;" />
        </div>
      </div>

      <div class="form-group">
        <label for="method">Método/Method:</label>
        <select v-model="formData.method" id="method" required>
          <option value="kinetic">Cinético de Jaffe compensado/Compensated Jaffe's kinetic</option>
          <option value="enzymatic">Enzimático/Enzymatic</option>
        </select>
      </div>
      
      <button type="submit">Calcular/Calculate</button>
    </form>
    <div v-if="results && results.tfgCurrent > 0 && !alertColor" class="results">
      <h2>Resultados/Results</h2>
      <p>TFG actual/current GFR: <b> {{ results.tfgCurrent }} ml/min/1,73m<sup>2</sup></b> </p>
      <p>TFG esperada/Expected GFR: <b>{{ results.tfgExpected }} ml/min/1,73m<sup>2</sup></b> </p>
    </div>
  </div>
</template>

<script>
import creatinineData from '@/data/creatinineData.json';

export default {
  data() {
    return {
      formData: {
        sex: 'M',
        age: '',
        ageUnit: 'years',
        height: '',
        method: 'kinetic',
        creatinine: '',
        umol: '',
        type: '',
        umol_L: '',
      },
      alertColor: false,
      results: {
        tfgCurrent: '',
        tfgExpected: '',
        creatinineUmol: '',
        creatinineMg: 0,
      },
      reference: null,
    };
  },
  computed: {
    isUmolSet() {
      return this.formData.umol > 0;
    },
  },
  methods: {
    calculate() {
      const height = parseFloat(this.formData.height);
      const age = parseFloat(this.formData.age);
      if (!height || !age) {
        this.alertColor = true;
        this.results = {
          tfgCurrent: null,
          tfgExpected: null,
          creatinineUmol: null,
          creatinineMg: null,
        };
        return;
      }
      this.alertColor = false;
      const sex = this.formData.sex;
      const ageUnit = this.formData.ageUnit;
      const method = this.formData.method;
      const mg_dL = parseFloat(this.formData.creatinine);
      const umol_L = parseFloat(this.formData.umol);

      // Buscar la referencia correcta
      const reference = creatinineData.find(
        (item) => item.sex === sex && this.isAgeInRange(age, ageUnit, item)
      );
      this.reference = reference;

      if (reference) {
        const sCrE = method === 'kinetic' ? reference.kinetic : reference.enzymatic;
        const creatinineUmol = umol_L / 88.4;
        let tfgCurrent = null;
        let tfgExpected = (0.413 * height) / sCrE;
        if (creatinineUmol) {
          tfgCurrent = (0.413 * height) / creatinineUmol;
        } else {
          tfgCurrent = (0.413 * height) / mg_dL;
        }
        this.results = {
          tfgCurrent: isNaN(tfgCurrent) ? 'NaN' : Math.round(tfgCurrent),
          tfgExpected: isNaN(tfgExpected) ? 'NaN' : Math.round(tfgExpected),
          creatinineUmol: creatinineUmol.toFixed(2),
          creatinineMg: (mg_dL * 88.4).toFixed(2),
        };
        this.alertColor = false;
      } else {
        this.alertColor = true;
        this.results = {
          tfgCurrent: 0,
          tfgExpected: 0,
          creatinineUmol: 0,
          creatinineMg: 0,
        };
      }
    },

    isAgeInRange(age, ageUnit, referenceItem) {
      if (ageUnit === 'years' && 'years' in referenceItem) {
        return age === referenceItem.years;
      } else if (ageUnit === 'months' && 'month' in referenceItem) {
        return age === referenceItem.month;
      }
      return false;
    }
  },
};
</script>


<style scoped>
.calculator-form {
  width: 380px;
  margin: 10px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.alert {
  border: 1px solid red;
}

.calculator-form h1 {
  text-align: center;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
}

.form-group label{
  font-weight: bold;
  margin-top: 10px;
  margin-right: 10px;
  text-align: left;
}

.form-group input,
.form-group select {
  width: calc(100% - 10px);
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
}

.calculator-form > form > button {
  width: 100%;
  padding: 10px;
  background-color: #007bff;
  margin-top: 10px;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 16px;
}

.calculator-form > input[type="number"],
.calculator-form > input[type="radio"] {
  width: 100%; /* Ajuste el ancho al 100% del contenedor */
  padding: 8px;
  margin-top: 5px;
  border: 1px solid #ccc;
  border-radius: 5px;
  box-sizing: border-box;
  appearance: none; /* Elimina estilos predeterminados en algunos navegadores */
}

.calculator-form > input[type="radio"] {
  width: auto; /* Permitir que el radio button tenga su tamaño natural */
  margin-right: 10px; /* Añadir un margen a la derecha para separación del label */
}

/* Asegurarse de que el formulario se ajuste correctamente en dispositivos móviles */
@media (max-width: 600px) {
  .calculator-form {
    padding: 10px;
  }

  .calculator-form > input[type="number"] {
    font-size: 16px; /* Tamaño de fuente más grande para mejor accesibilidad */
  }
}

button:hover {
  background-color: #0056b3;
}

.results {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f9f9f9;
}

#ageField{
  width: 50px;
}
</style>
